import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { NgbModal, NgbPopoverConfig } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, OccEndpointsService, RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { of, Subscription } from "rxjs";
import { filter, switchMap, take } from "rxjs/operators";
import { CustomAddToCartService } from "src/app/custom-add-to-cart/custom-add-to-cart.service";
import { CustomProdPgService } from "src/app/custom-prod-pg/custom-prod-pg.service";
import * as _ from 'underscore';
import { SharedService } from "../../services/shared.service";
import { ProductUtils } from "../../utils/productUtils";
import { LoactionStripService } from "../location-strip/loaction-strip.service";
import { FutureCartService } from "./future-cart.service";

@Component({
  selector: 'app-future-cart',
  templateUrl: './future-cart.component.html',
  styleUrls: ['./future-cart.component.scss'],
})
export class FutureCartComponent implements OnInit {
  futuerShipList = [];
  baseUrl = this.occEndPoint.getBaseUrl({
    baseUrl: true,
    prefix: false,
    baseSite: false,
  });
  isUnitAdded = false;
  isSelectedMultipleLoc = false;
  defaultImg = '';
  selectedLocs: any;
  selectedContractGroup: any = [];
  cartItemsSub: Subscription;
  cartItems: any;
  cartId: any;
  userDetails: any;
  updatedCartSub: Subscription;
  productList = [];
  getFutureCartSub: Subscription;
  isImagePresent = false;
  priceDetails = [];
  contractGroups = [];
  baseSiteId = '';
  updateErrSub: Subscription;
  isFormularyCustomer = false;
  formularyStatus = '';

  constructor(
    private readonly occEndPoint: OccEndpointsService,
    public modal: NgbModal,
    private readonly locService: LoactionStripService,
    private readonly cd: ChangeDetectorRef,
    private readonly plpService: CustomProdPgService,
    private readonly user: UserAccountFacade,
    private readonly futureCartService: FutureCartService,
    private readonly sharedService: SharedService,
    private readonly route: RoutingService,
    private baseSiteService: BaseSiteService,
    private readonly addToCart: CustomAddToCartService,
    private readonly config: NgbPopoverConfig
  ) {
    config.autoClose = 'outside';
  }
  blockOrder: boolean;

  ngOnInit(): void {
    let userId = this.sharedService.getLocalStorage('userId');
    let accountId = this.sharedService.getLocalStorage('accountId');
    this.blockOrder = this.sharedService.getLocalStorage('blockOrder');
    //this.futureCartService.getFutureShipCarts(userId, accountId);
    this.getFutureCartSub = this.futureCartService.futureShipCarts$
      .pipe(filter(res => !!res),
        switchMap((searchRes) => {
          //using underscore js we are plucking out all product's variants codes
          return of({
            codes: _.chain(searchRes['product'])
              .flatten()
              .pluck('code')
              .value(),
            searchResult: searchRes['product']
          });
        })
      )
      .subscribe((res) => {
        this.futuerShipList = res['searchResult'];
        let productListCopy = res['searchResult'];
        let req = {
          productCodes: res.codes,
          b2bUnitId: accountId,
        };
        if (res.codes.length > 0) {
          this.plpService.getProductPrices(req).subscribe((prices) => {
            if (prices) {
              this.priceDetails = prices.priceAndAvailability;
              _.each(productListCopy, (prod) => {
                prod['priceInfos'] =
                  this.priceDetails[
                  _.findIndex(this.priceDetails, { code: prod.code })
                  ];
              });
              this.futuerShipList = JSON.parse(
                JSON.stringify(productListCopy)
              );
              this.cd.detectChanges();
              this.getFutureCartSub?.unsubscribe();
            }
          });
        }
      });
    // }
    // }
    //);
    //this.locService.emitSelectedLocs.subscribe((res) => {
    this.selectedLocs = JSON.parse(sessionStorage.getItem('selectedLocations'));
    if (JSON.parse(sessionStorage.getItem('selectedLocations'))?.length <= 1) {
      this.isSelectedMultipleLoc = false;
    } else if ((!sessionStorage.getItem('selectedLocations')) || (JSON.parse(sessionStorage.getItem('selectedLocations'))?.length > 1)) {
      this.isSelectedMultipleLoc = true;
    }
    //});
    this.cartItemsSub = this.plpService.cartItems$.subscribe((res) => {
      if (res) {
        this.cartItems = res?.carts;
        this.cartItems = this.cartItems.filter(
          (item) => item?.saveTime === undefined
        );
      }
    });
    this.user.get().subscribe((res) => {
      if (res) this.userDetails = res;
    });
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => {
        this.baseSiteId = res;
        this.defaultImg = `../../../assets/icons/${this.baseSiteId}/sanofi_missing_product.jpg`
      });
    this.isFormularyCustomer = this.sharedService.getLocalStorage('formularyCustomer');
    this.cd.detectChanges();

  }

  getImage(product: []) {
    let tempImg;
    if (product['images'] && product['images'].length > 0) {
      const imagesFormat = _.clone(
        _.findWhere(product['images'], { format: 'thumbnail' })
      );
      if (imagesFormat) {
        imagesFormat.url = `${this.baseUrl}${imagesFormat?.url}`;
      }
      tempImg = imagesFormat.url;
    } else {
      tempImg = this.defaultImg;
    }
    return tempImg;
  }

  performQuantityComputation(
    operator,
    idData,
    quantityPerUnit,
    unitType,
    product
  ): void {
    ProductUtils.alterNewQuantity(
      operator,
      idData,
      quantityPerUnit,
      unitType,
      'flu'
    );
    const inputElement = document.getElementById(
      `prodQuantity${idData}`
    ) as HTMLInputElement;
    let temp = this.productList.find((x) => x.code === idData);
    if (temp)
      this.productList.splice(
        this.productList.findIndex((x) => x.code === idData),
        1
      );
    if (Number(inputElement.value) > 0)
      this.productList.push({
        code: idData,
        quantity: inputElement.value,
        product: product,
      });
    if (this.productList.length > 0) this.isUnitAdded = true;
  }

  checkOutOrAddToCart(isCheckout): void {
    const data = [];
    for (let i = 0; i < this.productList.length; i++) {
      let contractInfo: any;
      if (this.productList[i].product?.priceInfos?.conditions?.length > 1)
        contractInfo = this.selectedContractGroup.filter(x => x.code == this.productList[i].code).map((x) => {
          return x.contractGroup;
        })
      data.push({
        product: {
          code: this.productList[i].code,
        },
        quantity: this.productList[i].quantity,
        basePrice: {
          value: this.productList[i].product?.priceInfos?.price
            ? '' + this.productList[i].product?.priceInfos?.price?.value
            : '0',
        },

        contractInfo: {
          contractId:
            this.productList[i].product?.priceInfos?.conditions?.length == 1
              ? this.productList[i].product?.priceInfos.conditions[0].contractId
              : (contractInfo ? contractInfo[0]?.contractId || '' : ''),
          contractDesc:
            this.productList[i].product?.priceInfos?.conditions?.length == 1
              ? this.productList[i].product?.priceInfos.conditions[0]
                .contractDesc
              : (contractInfo ? contractInfo[0]?.contractDesc || '' : ''),
          contractPrice: {
            value:
              this.productList[i].product?.priceInfos?.conditions?.length == 1
                ? this.productList[i].product?.priceInfos.conditions[0]
                  .contractPrice.value
                : (contractInfo ? contractInfo[0]?.contractPrice?.value || 0 : ''),
          },
        },
        futureShipExpProd: true,
        fromFutureShipPopup: true
      });
      //this.itemAddedQuantity = inputElement.value;

    }
    let param = {};
    param['entries'] = data;
    param['selectedLocationIds'] = JSON.parse(sessionStorage.getItem('selectedLocations'))?.length > 0 ?
      JSON.parse(sessionStorage.getItem('selectedLocations'))?.map((data) => {
        return data?.accountNumber
      }) : [];
    if (this.cartItems && this.cartItems?.length === 0) {
      this.plpService.getCarts(this.userDetails?.uid);
      this.UpdateCartDetails(param, isCheckout);
    } else {
      if (this.cartId === undefined) {
        this.cartItems =
          this.cartItems && this.cartItems?.length > 0
            ? this.cartItems[this.cartItems?.length - 1]
            : [];
        this.cartId = this.cartItems?.code;
      }
      this.UpdateCartDetails(param, isCheckout);
    }
  }
  UpdateCartDetails(params, isCheckout) {
    //this.futureCartService.updateCart(params, this.userDetails?.uid, this.cartId)
    this.updatedCartSub = this.futureCartService.addToCart(this.userDetails?.uid, params, this.cartId, this.productList).subscribe(
      (res) => {
        if (res) {
          this.modal.dismissAll();
          if (isCheckout) this.route.goByUrl('/cart');
          this.sharedService.setLocalStorage(
            'futureshipAction', 'checkout'
          )
          this.sharedService.setLocalStorage(
            'futureshipModalOpened', true
          )
          this.addToCart.getAllCarts(this.userDetails?.uid);
        }
      }
      , (error) => {
        this.updateErrSub = this.plpService.updateError$.subscribe((res) => {
          if (res)
            this.updateErrSub?.unsubscribe();
        })
      }
    );
  }

  getPrice(item) {
    return item.priceInfos.price
      ? item.priceInfos.price.formattedValue
      : item.priceInfos.conditions?.length == 1
        ? item.priceInfos.conditions[0].contractPrice.formattedValue
        : this.selectedContractGroup?.contractPrice?.formattedValue || '$--';
  }

  onChange(event, productCode) {
    this.selectedContractGroup?.splice(
      this.selectedContractGroup.findIndex((x) => x.code === productCode),
      1
    );
    this.selectedContractGroup.push({ code: productCode, contractGroup: event });
    const inputElement = document.getElementById(
      `${productCode}`
    ) as HTMLInputElement;
    inputElement.innerHTML = event.contractPrice?.formattedValue;
  }

  ngOnDestroy() {
    this.getFutureCartSub?.unsubscribe();
    this.futuerShipList = [];
    this.plpService.updateError.next(false);
    this.updatedCartSub?.unsubscribe();
  }

  validateInput(event) {
    if (event.keyCode === 69) {
      return false;
    }
    else {
      var reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
      return new RegExp(reg).test(event.key);
    }
  }

  navigateFormulary(popover) {
    let string = `/formulary`;
    this.route.goByUrl(string);
    this.modal.dismissAll();
    popover.close();
  }

  openPopup(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  getFormularyStatus(formularyProduct) {
    if (this.isFormularyCustomer) {
      return formularyProduct ? true : false;
    } else {
      return true;
    }

  }
}
